module.exports = __webpack_public_path__ + "site/img/108.6ba409be.jpg";